<div class="date-range-toolbar-item" matTooltip="{{toolTip}}">
	<img src="assets/app/img/icons/arrow-down.svg" (click)="onDateRangeToolBarClick(element)" clickOutSideExclude>
	<div class="label" #element (click)="onDateRangeToolBarClick(element)" clickOutSideExclude>{{startDate}} - {{endDate}}</div>
</div>
